import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "../i18n";

export const MobileCTA = () => {
  const { data, t } = useLang();
  const { SITE } = data;
  return (
    <div
      data-testid="mobile-cta-bar"
      className="sm:hidden fixed bottom-0 inset-x-0 z-40 bg-cream/90 backdrop-blur-xl border-t border-sand px-4 py-3 flex gap-3"
    >
      <a
        href={SITE.phoneHref}
        data-testid="mobile-cta-call-button"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-sage py-3 text-[13px] font-semibold text-sage"
      >
        <Phone className="w-4 h-4" /> {t.mobileCta.call}
      </a>
      <a
        href={SITE.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-cta-whatsapp-button"
        aria-label={t.mobileCta.whatsapp}
        className="inline-flex items-center justify-center w-12 rounded-full border border-sage text-sage"
      >
        <MessageCircle className="w-5 h-5" />
      </a>
      <a
        href={SITE.bookingUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-cta-booking-button"
        className="flex-[1.4] inline-flex items-center justify-center rounded-full bg-terra py-3 text-[13px] font-semibold text-cream"
      >
        {t.mobileCta.book}
      </a>
    </div>
  );
};
